import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

interface PreviewModalProps {
  landscape: boolean;
}

function PreviewModal({landscape}: PreviewModalProps): JSX.Element {
  return (
    <div className="pdf-preview-modal">
      <p className="status" />
      <div className="preview-wrapper">
        {landscape ? (
          <svg
            width="388.235"
            height="300"
            viewBox="0, 0, 1100, 850"
            style={{backgroundColor: 'white', boxShadow: '0px 0px 2px', verticalAlign: 'middle'}}
            className="preview-container"
          />
        ) : (
          <svg
            width="300"
            height="388.235"
            viewBox="0, 0, 850, 1100"
            style={{backgroundColor: 'white', boxShadow: '0px 0px 2px', verticalAlign: 'middle'}}
            className="preview-container"
          />
        )}
      </div>
      <div className="row pagination-row">
        <div className="col-md-4">
          <div className="btn-group">
            <button type="button" className="first-btn btn btn-af-default">
              <span className="glyphicon glyphicon-fast-backward" />
            </button>
            <button type="button" className="prev-btn btn btn-af-default">
              <span className="glyphicon glyphicon-step-backward" />
            </button>
          </div>
        </div>
        <div className="page-count col-md-4">Page 1 of 1</div>
        <div className="col-md-4">
          <div className="btn-group">
            <button type="button" className="next-btn btn btn-af-default">
              <span className="glyphicon glyphicon-step-forward" />
            </button>
            <button type="button" className="last-btn btn btn-af-default">
              <span className="glyphicon glyphicon-fast-forward" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<PreviewModalProps>(PreviewModal);
